// Copyright (c) 2017 Deere & Company

export const loadAllAccounts = dealerAccountsFacet =>
    dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

export const loadAllReturnStatuses = partReturnStatusesFacet =>
    partReturnStatusesFacet.isInitialLoad || partReturnStatusesFacet.selectedStatuses.length === 0;

export const loadDefaultRequestDates = requestDateFacet =>
    requestDateFacet.isInitialLoad;

export const isRequestTypeFacetInvalid = facets =>
    !facets.selectedTypes.length;



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/facets-services.js